module.exports = __webpack_public_path__ + "static/media/icon-phone.20bd0c83.svg";